<template>
    <div>
        <template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }" >
                <b-form @submit.prevent="handleSubmit(submitProductMaterial)">
                    <b-row >
                        <b-col cols="auto" md="6">
                            
                            <!-- Code Interlining -->
                            <validation-provider
                                name="codeInterlining"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Code
                                    </template>
                                    
                                        <!-- <b-form-select id="inputCodeInterlining" v-model="form.codeInterlining"  :options="codeOpt" :state="getValidationState(validationContext)"  trim></b-form-select> -->
                                        <v-select append-to-body
                                            :reduce="ref => ref.code" 
                                            v-model="form.codeInterlining"
                                            @input="setSelected" 
                                            :options="codeOpt" 
                                            placeholder="Type your code number"
                                            label="ref">
                                            <template #list-header>
                                                <b-input-group-append>
                                                    <b-button block variant="light" @click="showMaster()">
                                                        <!-- <b-icon icon="eye-fill" aria-label="Help"></b-icon> -->
                                                        Lihat Semua
                                                    </b-button>
                                                </b-input-group-append>
                                            </template>
                                            <template #option="{ code, description }">
                                                <p style="margin: 0">{{ code }}</p>
                                                <em class="text-muted">{{ description }}</em>
                                            </template>
                                        </v-select>
                                        
                                    
                                    <b-form-invalid-feedback id="inputCodeInterlining">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Type Interlining -->
                            <validation-provider
                                name="TypeInterlining"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4"  
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Type
                                    </template>
                                
                                    <b-form-input readonly id="inputTypeInterlining" v-model="form.typeInterlining"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                    <b-form-invalid-feedback id="inputTypeInterlining">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Description -->
                            <validation-provider
                                name="DescriptionInterlining"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Description
                                    </template>
                                
                                    <b-form-input readonly id="DescriptionInterlining" v-model="form.descriptionInterlining"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                    <b-form-invalid-feedback id="DescriptionInterlining">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Detail Interlining -->
                            <validation-provider
                                name="DetailInterlining"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Detail
                                    </template>
                                
                                    <b-form-textarea id="DetailCodeInterlining" v-model="form.detailInterlining"  :state="getValidationState(validationContext)"  trim></b-form-textarea>
                                    <b-form-invalid-feedback id="DetailCodeInterlining">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <!-- UsedInterlining -->
                            <!-- <validation-provider
                                name="UsedInterlining"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Used As
                                    </template>
                                    <b-form-select id="inputUsedInterlining" v-model="form.usedInterlining"  :options="usedOpt" :state="getValidationState(validationContext)"  trim></b-form-select>
                                    <b-form-invalid-feedback id="inputUsedInterlining">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider> -->
                            <b-form-group
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Images
                                </template>
                                    <b-img v-bind="mainProps" thumbnail fluid :src="form.imagesInterlining" ></b-img>

                            </b-form-group>
                            
                            <div>
                                <b-button block  variant="warning" v-on:click="clearForm()">Cancel</b-button>
                                <b-button block  variant="success" type="submit">Save</b-button>
                            </div>
                            
                        </b-col>
                        <b-col cols="auto" md="6">
                            <b-card sub-title="Material History">
                                <b-table
                                    responsive
                                    show-empty
                                    small
                                    fixer
                                    :items="loadMaterialHistory"
                                    :fields="fieldsApprove"
                                >
                                    <template #cell(date)='{item}'>
                                        {{new Date(item.date).toLocaleString("id-ID")}}
                                    </template>
                                </b-table>
                            </b-card>
                        </b-col>
                    </b-row>
                        
                </b-form>
            </validation-observer>
        </template>
        <template>
            <b-table
                responsive
                striped 
                hover
                :items="loadProductMaterial"
                :fields="fields"
                show-empty
            >
                
                <template #cell(images)="{item}"   >
                    <p class="small" v-for="img in item.images" :key="img.src">
                        <a :href="img.src" target="_blank">{{img.fileName.substring(0,26)}}</a>
                    </p>
                </template>
                <template #cell(actions)="{item}">
                    <b-button title="Hapus" size="xs" variant="danger" v-on:click="updateMaterial(item.product_material_id)">
                        <b-icon icon="trash-fill" aria-label="Help"></b-icon>
                    </b-button>
                    <b-button title="Ubah" size="xs" variant="warning" v-on:click="editData(item.product_material_id)">
                        
                        <b-icon icon="pencil-square" aria-label="Help"></b-icon>
                        
                    </b-button>
                    <b-button title="View" size="xs" variant="dark" v-on:click="modalInterliningView = true">
                        
                        <b-icon icon="eye-fill" aria-label="Help"></b-icon>
                    </b-button>
                </template>
            </b-table>
        </template>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import 'vue-select/dist/vue-select.css';
export default {
    props:['productId'],
    data(){
        return{
            mainProps: {width: 150, class: 'm1' },
            formName: 'Interlining',
            modulName: null,
            tabIndex:1,
            isValid:false,
            dataInterlining:[],
            
            fields:[
                {key:'actions', label:'#'},
                'code','type','description',
                {key:'images', label:'Images'},
                'detail',
                'used_as'
            ],
            imagesUrl:[],
            form:{
                productMaterialId:null,
                codeInterlining:null,
                typeInterlining:null,
                imagesInterlining:[],
                detailInterlining:null,
                usedInterlining:null,
                descriptionInterlining:null,
                interliningId:null,
                category:'interlining',
                statusInterlining:null,
                
            },
            codeOpt:[
                {code:'Code A', ref:'Code A'},
                {code:'Code B', ref:'Code B'},
                {code:'Code C', ref:'Code C'},
                {code:'Code D', ref:'Code D'},
                
            ],
            usedOpt:[
                {value:'Main', text:'Main'},
                {value:'Combo 1', text:'Combo 1'},
                {value:'Combo 2', text:'Combo 2'},
                {value:'Combo 3', text:'Combo 3'},
            ],
            interliningOpt: [
                { item: 'tbd', name: 'TBD', notEnabled: true },
                { item: 'yes', name: 'Yes' },
                { item: 'no', name: 'No', notEnabled: true},
                
            ],
            isSelect:'yes',
            modalMaster:false,
            modalInterliningView:false,
            fieldsApprove:[
                {key:'date',label:'Date'},
                'status','comment','code'
                // {key:'created_by', label:'Approve By'}
            ],
        }
    },
    methods:{
        ...mapActions('productDesign',['GET_PRODUCT_MATERIAL_DEV','POST_PRODUCT_MATERIAL','PUT_PRODUCT_MATERIAL']),
        ...mapActions('masterPLM',['GET_MASTER_MATERIAL']),
        
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        getProductMaterial(){
            // console.log('id',this.productId);
            this.GET_PRODUCT_MATERIAL_DEV({
                product:this.productId
            }).then(rsp=>{
                // console.log('data',rsp.data.payload.filter(i=>i.category ==='interlining' ))
                let data = rsp.data.payload.filter(i=>i.category ==='interlining' && i.product_id === this.productId)

                this.dataInterlining = data
            }).catch(err=>{
                return err
            })
        },
        getInterliningMaster(){
            this.GET_MASTER_MATERIAL().then(response => {
                this.codeOpt = []
                    let objInterlining = response.data.payload.filter(x=>x.category === 'interlining')
                    for(var i=0;i<objInterlining.length;i++){
                        
                            let arrInterlining = {
                                ref: objInterlining[i].code,
                                code: objInterlining[i].code,
                                description:objInterlining[i].description,
                            }
                            this.codeOpt.push(arrInterlining)
                    }
                    
            })
            .catch(error => {
                if (error.response.status === 400){
                     this.errorMessage = error.response.data.message
                }
            })
        },
        clearForm(){
            this.form.indexId = null
            this.form.codeInterlining = null
            this.form.typeInterlining = null
            this.form.imagesInterlining = []
            this.imagesUrl = []
            this.form.detailInterlining = null
            this.form.usedInterlining = null
            this.form.interliningId = null
            this.form.descriptionInterlining = null
            this.form.productMaterialId     = null
            this.form.statusInterlining = null
            this.$refs.observer.reset()
        },
        setSelected(value){
            // console.log(value);
            if(value != null){
                let dataInterlining = this.MASTER_MATERIAL.filter(x => x.code === value)
                // console.log(dataInterlining);
                this.form.interliningId= dataInterlining[0].id
                this.form.codeInterlining= dataInterlining[0].code
                this.form.typeInterlining= dataInterlining[0].type
                this.form.descriptionInterlining = dataInterlining[0].description
                this.form.imagesInterlining = dataInterlining[0].img_src
            }else{
                console.log('belum ada data')
            }
        },
        submitProductMaterial(){
                let productMaterial = []
                let interlining = {
                    category: this.form.category,
                    material_id: this.form.interliningId,
                    code: this.form.codeInterlining,
                    type: this.form.typeInterlining,
                    used_as: this.form.usedInterlining,
                    detail: this.form.detailInterlining,
                    description: this.form.descriptionInterlining,
                    status:'new',
                    is_proccess:'active'
                }    
                productMaterial.push(interlining)

            if(this.form.productMaterialId){
                this.PUT_PRODUCT_MATERIAL({
                    product_material_id:this.form.productMaterialId,
                    detail:this.form.detailInterlining,
                    used_as:this.form.usedInterlining,
                    process:this.form.statusInterlining
                }).then(rsp=>{
                    console.log('berhasil dihapus');
                    this.getProductMaterial()
                    this.clearForm()
                })
            }else{
                this.POST_PRODUCT_MATERIAL({
                product_id:this.productId,
                material:productMaterial

            })
                .then(response => {
                    console.log('success submit product material');
                    this.getProductMaterial()
                    this.clearForm()
                })
                .catch(error => {
                    console.log('material save',error);
                })
            }  
            
        },
        editData(id){
            let data = this.dataInterlining.filter(i=>i.product_material_id === id)
            // console.log('edit data',data);

            this.form.productMaterialId     = id
            this.form.interliningId              = data[0].id
            this.form.codeInterlining            = data[0].code
            this.form.typeInterlining            = data[0].type
            this.form.detailInterlining          = data[0].detail
            this.form.usedInterlining            = data[0].used_as
            this.form.descriptionInterlining     = data[0].description
            this.form.statusInterlining          = data[0].product_material_proccess
        },
        updateMaterial(id){
            this.PUT_PRODUCT_MATERIAL({
                product_material_id:id,
                detail:this.form.detailInterlining,
                used_as:this.form.usedInterlining,
                process:'drop'
            }).then(rsp=>{
                console.log('berhasil dihapus');
                this.getProductMaterial()
                this.clearForm()
            })
        }

    },
    created(){
        this.getProductMaterial()
        this.getInterliningMaster()
    },
    computed:{
        
        ...mapGetters('masterPLM',['MASTER_MATERIAL']),
        ...mapGetters('productDesign',['GET_MATERIAL_HISTORY']),
        loadMaterialHistory(){
            
            return this.GET_MATERIAL_HISTORY.filter(i=>i.category === 'interlining')
        },
        loadProductMaterial(){
           
            return this.dataInterlining
        }
    }
}
</script>